import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { userService } from "../../_services";
import logo from "../../Assets/dataco_logo-NEW.png";

class LoginPageBase extends React.Component {
  constructor(props) {
    super(props);

    userService.logout();

    this.state = {
      username: "",
      password: "",
      submitted: false,
      loading: false,
      error: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });
    const { username, password } = this.state;

    if (!(username && password)) {
      return;
    }

    this.setState({ loading: true });
    userService.login(username, password).then(
      (user) => {
        if (user != null) {
          const { navigate, location } = this.props.router;
          const from = location.state?.from?.pathname || "/";
          navigate(from, { replace: true });
        } else {
          this.setState({ loading: false });
        }
      },
      (error) => this.setState({ error, loading: false })
    );
  }
    render() {
        const { username, password, submitted, loading, error } = this.state;
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                flex: 1,
                padding: '20px'
            }}>
                <div style={{ 
                    width: '100%', 
                    maxWidth: '400px',
                    padding: '30px',
                    background: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
                }}>
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        marginBottom: '30px'
                    }}>
                        <img src={logo} alt="Logo" style={{ maxWidth: '200px' }} />
                    </div>
                    <form name="form" onSubmit={this.handleSubmit}>
                        <div class={'form-group' + (submitted && !username ? ' has-error' : '')}>
                            <label htmlFor="username">Username</label>
                            <input type="text" class="form-control" name="username" value={username} onChange={this.handleChange} />
                            {submitted && !username &&
                                <div class="help-block">Username is required</div>
                            }
                        </div>
                        <div class={'form-group' + (submitted && !password ? ' has-error' : '')}>
                            <label htmlFor="password">Password</label>
                            <input type="password" class="form-control" name="password" value={password} onChange={this.handleChange} />
                            {submitted && !password &&
                                <div class="help-block">Password is required</div>
                            }
                        </div>
                        <div class="form-group" style={{ marginTop: '20px', marginBottom: '10px' }}>
                            <button 
                                class="btn btn-primary" 
                                disabled={loading}
                                style={{ 
                                    width: '100%',
                                    padding: '10px',
                                    marginTop: '10px',
                                    marginBottom: '10px'
                                }}
                            >
                                Login
                            </button>
                            {loading &&
                                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                    <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                </div>
                            }
                        </div>
                        {error &&
                            <div class={'alert alert-danger'} style={{ marginTop: '15px' }}>{error}</div>
                        }
                    </form>
                </div>
            </div>
        );
    }
}

// ✅ wrapper to inject hooks into class component
function withRouter(Component) {
  return (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    return <Component {...props} router={{ navigate, location }} />;
  };
}

export const LoginPage = withRouter(LoginPageBase);  // rename the class to LoginPageBase
